import { getToken, clearAuth } from './auth';

const BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

/**
 * multipart/form-data 上传（CSV 导入等），按 ResponseResult 解析
 * @param {string} url
 * @param {FormData} formData
 * @returns {Promise<*>}
 */
export async function uploadMultipart(url, formData) {
    const headers = {};
    const token = getToken();
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${BASE_URL}${url}`, {
        method: 'POST',
        headers,
        body: formData,
    });

    let result;
    try {
        result = await response.json();
    } catch {
        throw new Error('服务器响应格式错误');
    }

    const status = result.status != null ? String(result.status) : '';

    if (status === '401') {
        clearAuth();
        window.location.href = '/login';
        throw new Error(result.message || '未登录或令牌无效');
    }

    if (status === '403') {
        throw new Error(result.message || '无权访问');
    }

    if (status !== '200') {
        throw new Error(result.message || '上传失败');
    }

    return result.data;
}

export default uploadMultipart;
